import React from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';

import './frontBeforeStarted.scss';

function FrontBeforeStarted() {
  return (
    <div id="container">
      <div className="grid container_box">
        <div className="title">
          <h2>FAQs before getting started with UPshow</h2>
        </div>
        <div className="col-12 accordion-demo">
          <div className="acordion">
            <Accordion>
              <AccordionTab header="What do I do once I receive my device?">
                <p className="faq-item">
                  Plug in your device, connect to the internet and that&apos;s it! If you have any questions, not to worry:
                  UPshow&apos;s support team is available to help you. Once you&apos;re plugged in, you&apos;ll be able to
                  customize your screens via the UPshow Manager.
                </p>
              </AccordionTab>
              <AccordionTab header="Does UPshow require an internet connection?">
                <p className="faq-item">
                  Yes. When your UPshow device is plugged into a TV or AV system for the first time, you will be prompted to
                  connect a Wi-Fi network. If you choose to connect your UPshow device via ethernet, you will not need to connect
                  the device to a Wi-Fi network.
                </p>
              </AccordionTab>
              <AccordionTab header="How do I manage UPshow?">
                <p className="faq-item">
                  Using the UPshow Manager, you can control the content on your screens from your laptop, phone and tablet no
                  matter where you are!
                </p>
              </AccordionTab>
              <AccordionTab header="Are there usage limits?">
                <p className="faq-item">
                  No, there are no usage limits. Your UPshow device runs on your business&apos;s internet connection. As long as
                  your device is connected, you will be able to use UPshow.
                </p>
              </AccordionTab>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FrontBeforeStarted;
